export default __webpack_public_path__ + "static/media/wes-hicks-4-EeTnaC1S4-unsplash.068a9e59.jpg";